










































































import { Component, Vue } from 'vue-property-decorator'
import { Message, MessageBox } from 'element-ui'
import {
  GetActivityDailyRankRewardConfig,
  SaveActivityDailyRankRewardConfig,
  SettleActivityDailyRankReward,
  QueryCouponTemplateList,
} from '@/api'

interface ExactRow {
  rank: number
  contributionQty: number
  energyQty: number
  mungBeanQty: number
  pointsQty: number
  couponTemplateId?: number | null
  couponCount?: number | null
}

interface RangeRow {
  fromRank: number
  toRank: number
  contributionQty: number
  energyQty: number
  mungBeanQty: number
  pointsQty: number
  couponTemplateId?: number | null
  couponCount?: number | null
}

@Component({})
export default class ActivityDailyRankRewardConfig extends Vue {
  private couponTemplateOptions: any[] = []
  private settlePickDate: string | null = null
  private cfg: {
    enabled: boolean
    settleRankLimit: number
    minDayActivityQty: number
    contributionExchangeRatio: number
    exactRanks: ExactRow[]
    rangeRewards: RangeRow[]
    note: string
  } = {
    enabled: false,
    settleRankLimit: 100,
    minDayActivityQty: 0,
    contributionExchangeRatio: 0,
    exactRanks: [],
    rangeRewards: [],
    note: '',
  }

  public created(): void {
    this.loadCouponTemplateOptions()
    this.load()
  }

  private async loadCouponTemplateOptions(): Promise<void> {
    this.couponTemplateOptions = (await QueryCouponTemplateList({ enabledOnly: true })) || []
  }

  private couponTemplateOptionLabel(t: any): string {
    if (!t) {
      return ''
    }
    const name = t.name || ''
    return name ? `${name}（ID:${t.id}）` : `模板ID:${t.id}`
  }

  /** 下拉清空为 null；保存前统一为 0 或模板ID + 固定发 1 张 */
  private normalizeCouponFields(): void {
    const norm = (row: { couponTemplateId?: number | null; couponCount?: number | null }) => {
      const tid = row.couponTemplateId
      if (tid == null || tid <= 0) {
        row.couponTemplateId = 0
        row.couponCount = 0
      } else {
        row.couponCount = 1
      }
    }
    this.cfg.exactRanks.forEach(norm)
    this.cfg.rangeRewards.forEach(norm)
  }

  private normalizeCouponRowFromApi(row: any): void {
    const tid = row.couponTemplateId
    if (tid == null || tid <= 0) {
      row.couponTemplateId = null
      row.couponCount = 0
    } else {
      row.couponCount = 1
    }
  }

  private ensureExactRanks(): void {
    const ranks = [1, 2, 3]
    for (const r of ranks) {
      if (!this.cfg.exactRanks.some((x) => x.rank === r)) {
        this.cfg.exactRanks.push({
          rank: r,
          contributionQty: 0,
          energyQty: 0,
          mungBeanQty: 0,
          pointsQty: 0,
          couponTemplateId: null,
          couponCount: 0,
        })
      }
    }
    this.cfg.exactRanks.sort((a, b) => a.rank - b.rank)
  }

  private async load(): Promise<void> {
    const d = await GetActivityDailyRankRewardConfig()
    if (d) {
      this.cfg = {
        enabled: !!d.enabled,
        settleRankLimit: d.settleRankLimit != null ? d.settleRankLimit : 100,
        minDayActivityQty: d.minDayActivityQty != null ? Number(d.minDayActivityQty) : 0,
        contributionExchangeRatio: d.contributionExchangeRatio != null ? Number(d.contributionExchangeRatio) : 0,
        exactRanks: Array.isArray(d.exactRanks)
          ? d.exactRanks.map((x: any) => {
              const row = { ...x }
              this.normalizeCouponRowFromApi(row)
              return row
            })
          : [],
        rangeRewards: Array.isArray(d.rangeRewards)
          ? d.rangeRewards.map((x: any) => {
              const row = { ...x }
              this.normalizeCouponRowFromApi(row)
              return row
            })
          : [],
        note: d.note || '',
      }
    }
    this.ensureExactRanks()
    if (!this.cfg.rangeRewards.length) {
      this.cfg.rangeRewards = []
    }
  }

  private async save(): Promise<void> {
    this.normalizeCouponFields()
    await SaveActivityDailyRankRewardConfig(this.cfg)
    Message.success('保存成功')
    this.load()
  }

  private addRange(): void {
    this.cfg.rangeRewards.push({
      fromRank: 4,
      toRank: 10,
      contributionQty: 0,
      energyQty: 0,
      mungBeanQty: 0,
      pointsQty: 0,
      couponTemplateId: null,
      couponCount: 0,
    })
  }

  private removeRange(i: number): void {
    this.cfg.rangeRewards.splice(i, 1)
  }

  private async settleYesterday(): Promise<void> {
    await MessageBox.confirm('确定按「昨日」数据执行结算？已发过用户会自动跳过。', '提示', { type: 'warning' })
    await SettleActivityDailyRankReward({})
    Message.success('已触发结算')
  }

  private async settlePick(): Promise<void> {
    if (!this.settlePickDate) {
      Message.warning('请先选择日期')
      return
    }
    await MessageBox.confirm(`确定结算 ${this.settlePickDate} ？`, '提示', { type: 'warning' })
    await SettleActivityDailyRankReward({ rewardDate: this.settlePickDate })
    Message.success('已触发结算')
  }
}
